import React from "react";
import { CircularProgress } from "@mui/material";
import Axios from "axios";
import { useNavigate } from "react-router-dom";

const returnDate = (d) => {
  return new Date(d).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
const BugReports = () => {
  const [plans, setPlans] = React.useState(null);

  const navigate = useNavigate();
  const fetchStats = async () => {
    const { data } = await Axios({
      method: "get",
      url: "/api/activity/bugreports",
    });
    setPlans(data.data);
  };
  React.useEffect(() => {
    fetchStats();
  }, []);
  if (plans === null) {
    return <CircularProgress />;
  }
  return (
    <>
      <div className="container admin-user-activity">
        <h3>Reported Bugs</h3>
        {plans?.length > 0 ? (
          <table className="plan_table mt-24">
            <thead className="plan_thead activityplan_thead">
              <tr className="plan_thead_tr plan_tr">
                <th className="plan_thead_tr plan_td">Reported User</th>
                <th className="plan_thead_tr plan_td">Title</th>
                <th className="plan_thead_tr plan_td">Summary</th>
                <th className="plan_thead_tr plan_td">Attachment</th>
                <th className="plan_thead_tr plan_td">Reported at</th>
              </tr>
            </thead>
            <tbody className="plan_tbody">
              {plans.map((plan) => (
                <tr key={plan._id} className="plan_tbody_tr plan_tr">
                  <td className="plan_tbody_td plan_td">
                    <div
                      onClick={() =>
                        navigate(
                          `/admin/user-activity?tab=13&userid=${plan.user_id?._id}`
                        )
                      }
                      className="d-flex plan_tbody_logo align-items-center pointer"
                    >
                      {plan.user_id ? (
                        <>
                          <img src={plan?.user_id?.avatar} alt="logo" />
                          <div>
                            <p className="m-0">
                              {plan?.user_id?.name
                                ? plan?.user_id?.name
                                : `${plan?.user_id?.firstname} ${plan?.user_id?.lastname}`}
                            </p>
                            <p className="m-0 mt-8">{`${plan?.user_id?.email} (${plan?.user_id?.type})`}</p>
                          </div>
                        </>
                      ) : (
                        "Not Found"
                      )}
                    </div>
                  </td>
                  <td className="plan_tbody_td plan_td">{plan.title}</td>
                  <td className="plan_tbody_td plan_td">{plan.summary}</td>
                  <td className="plan_tbody_td plan_td">
                    <img height={50} width={100} src={plan?.snap} alt="logo" />
                  </td>
                  <td className="plan_tbody_td plan_td">
                    {returnDate(plan?.createdAt)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <h2>No Reports</h2>
        )}
      </div>
    </>
  );
};

export default BugReports;
